module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_vm._l((_vm.menuList), function(node, index) {
    return (node.name) ? [(_vm.menuLevel > 1) ? _c('span', {
      staticClass: "icon icon-right"
    }) : _vm._e(), _vm._v(" "), _c('li', {
      staticClass: "item-content"
    }, [_c('div', {
      staticClass: "item-title"
    }, [_c('a', {
      staticClass: "nav_t",
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          return _vm.closePanelAndRedirect(node.url)
        }
      }
    }, [_vm._v("\n                    " + _vm._s(node.name) + "\n                ")])]), _vm._v(" "), (node.child) ? _c('menu-item', {
      attrs: {
        "menuLevel": node.level,
        "menuList": node.child
      }
    }) : _vm._e()], 1)] : _vm._e()
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-195de59d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/MenuItem.vue
// module id = 233
// module chunks = 1